module.exports = __webpack_public_path__ + "img/frasco_inovah_500.8b940c67.png";